import { render } from "./Logo.vue.ts?vue&type=template&id=5f0f44ae&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=template&id=5f0f44ae&ts=true"
import script from "./Logo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/person-registration/shared-components/ui/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f0f44ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f0f44ae', __exports__)) {
    api.reload('5f0f44ae', __exports__)
  }
  
  module.hot.accept("./Logo.vue.ts?vue&type=template&id=5f0f44ae&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Logo.vue?vue&type=template&id=5f0f44ae&ts=true", () => {
    api.rerender('5f0f44ae', render)
  })

}


export default __exports__